import { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "./AuthContext";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  const location = useLocation();
  const { access } = useContext(AuthContext);

  if (!token) {
    return <Navigate to="/" />;
  }

  const currentPath = location.pathname;
  // const hasAccess = access.some((item) => item.menu_path === currentPath);
  const hasAccess = access.some((item) =>
    currentPath.startsWith(item.menu_path)
  );

  if (!hasAccess) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
